@if (tableOfContents.length) {
  <app-block-wrapper [_editable]="_editable" [style]="style">
    <app-toggler color="grey-80" iconPosition="left" headerSize="big" bodyPadding="big">
      <div togglerHeader>Table of Contents</div>
      <div togglerBody>
        <app-table-of-contents-item-list [items]="tableOfContents" [level]="0"></app-table-of-contents-item-list>
      </div>
    </app-toggler>
  </app-block-wrapper>
}
